import { VIDEO_SYNC_MONITOR_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import {
  BulkRetryRequest,
  BulkRetryResponse,
  TestSyncByTrackerRequest,
  TestSyncRequest,
  TestSyncResponse,
  VideoSyncStats,
  VideoSyncTracker,
} from '../types/videoSyncMonitorType';

class VideoSyncMonitorService extends ApiService<VideoSyncTracker> {
  constructor() {
    super(VIDEO_SYNC_MONITOR_API_PATH);
  }

  public async getStats(params?: URLSearchParams): Promise<VideoSyncStats> {
    return this.fetchBySubPathRaw<VideoSyncStats>('stats/', params);
  }

  public async retry(id: number): Promise<VideoSyncTracker> {
    return this.createBySubPath<VideoSyncTracker, object>(`${id}/retry`, {});
  }

  public async bulkRetry(ids: number[]): Promise<BulkRetryResponse> {
    return this.createBySubPath<BulkRetryResponse, BulkRetryRequest>('bulk_retry', { ids });
  }

  public async getFailed(
    params?: URLSearchParams
  ): Promise<{ results: VideoSyncTracker[]; count: number }> {
    return this.fetchBySubPath<VideoSyncTracker>('failed/', params);
  }

  public async getPending(
    params?: URLSearchParams
  ): Promise<{ results: VideoSyncTracker[]; count: number }> {
    return this.fetchBySubPath<VideoSyncTracker>('pending/', params);
  }

  public async testSync(data: TestSyncRequest): Promise<TestSyncResponse> {
    return this.createBySubPath<TestSyncResponse, TestSyncRequest>('test_sync', data);
  }

  public async testSyncByTracker(data: TestSyncByTrackerRequest): Promise<TestSyncResponse> {
    return this.createBySubPath<TestSyncResponse, TestSyncByTrackerRequest>(
      'test_sync_by_tracker',
      data
    );
  }
}

export const videoSyncMonitorService = new VideoSyncMonitorService();
